export default class {
  protected root;
  constructor(rootStore: any) {
    this.root = rootStore;
    this.init();
  }

  init() {
    // should be implement
  }
}
